module.exports = __webpack_public_path__ + "static/grafika4@2x-e2d10474334f19af4c2b546a4dc46654.png";